import { createContext, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

const ADMIN_EMAIL = 'ethan.younghoon.park@gmail.com';

const AdminContext = createContext();

export function AdminProvider({ children }) {
    const { user } = useAuth();
    const navigate = useNavigate();
    const [editing, setEditing] = useState(false);

    const isAdmin = !!user && user.email === ADMIN_EMAIL;
    const adminMode = isAdmin && editing;

    const toggleAdmin = () => {
        if (isAdmin) {
            setEditing((e) => !e);
            return;
        }
        if (!user) {
            // Not signed in — send them to log in as the admin account.
            navigate('/login');
        }
        // Signed in but not the admin: do nothing (no editing access).
    };

    return (
        <AdminContext.Provider value={{ adminMode, isAdmin, toggleAdmin }}>
            {children}
        </AdminContext.Provider>
    );
}

export const useAdmin = () => useContext(AdminContext);